const sizes = {
  xl: {
    xl: {
      width: '1380px',
    },
    lg: {
      width: '1140px',
    },
    md: {
      width: '960px',
    },
  },
  lg: {
    xl: {
      width: '1128px',
    },
    lg: {
      width: '1128px',
    },
    md: {
      width: '960px',
    },
  },

  md: {
    xl: {
      width: '768px',
    },
    lg: {
      width: '768px',
    },
    md: {
      width: '768px',
    },
  },

  sm: {
    xl: {
      width: '600px',
    },
    lg: {
      width: '600px',
    },
    md: {
      width: '600px',
    },
  },
};

export { sizes };
